<div class="row page-header">
    <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
            <h1 class="mb-0">Business Plan <small>Strategic roadmap with goals, objectives, and 3-year vision</small></h1>
            <button class="btn btn-secondary btn-sm" (click)="printDocument()" title="Print Business Plan">
                <fa-icon [icon]="faPrint"></fa-icon> Print
            </button>
        </div>
    </div>
</div>
@if (!isInitialLoading) {
    <div class="container-fluid" style="padding-top: 20px">
        <div class="row">
            <div class="col-12">
                <app-business-plan-summary [sections]="sections" [canEdit]="canEdit"> </app-business-plan-summary>
            </div>
        </div>
    </div>
}
